<template>
  <div class="d-flex align-items-center">
    <b-popover target="contactsDetails" placement="bottom">
      <p class="contacts__text">{{$t('labels.common.contact_details')}}</p>
      <p class="contacts__text"><a target="_blank" :href="SERVICE_DESK_URL">Service Desk</a></p>
    </b-popover>
    <icon
        @click="clearCache"
        name="eraser"
        class="contacts__icon mr-0"/>
    <icon
      id="contactsDetails"
      name="phone-square"
      class="contacts__icon"/>
  </div>
</template>
<script>
import { SERVICE_DESK_URL } from '@/constants'

export default {
  data () {
    return {
      SERVICE_DESK_URL
    }
  },
  methods: {
    async clearCache () {
      const result = await this.$swal.fire({
        title: this.$i18n.t(`modal_dialogs.sure_attempt`),
        text: 'This action will clear all the cache and you will have to login again.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$i18n.t(`buttons.common.cancel`)
      })
      if (result.value) {
        this.$store.cache.clear()
        sessionStorage.clear()
        localStorage.clear()
        this.deleteAllCookies()
        window.location.reload(true)
      }
    },
    deleteAllCookies() {
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
          let cookie = cookies[i];
          let eqPos = cookie.indexOf("=");
          let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .contacts__icon {
    width: 26px;
    height: 26px;
    color: #364868;
    margin: 0 15px;
    cursor: pointer;
  }

  .contacts__text {
    margin-bottom: 0.5rem;
    font-size: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Contacts.vue